import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ConcreteLayer} from "../../classes/concreteLayers/ConcreteLayer";
import {ConcreteHierarchyItemInterface} from "../../classes/concreteLayers/ConcreteHierarchyItemInterface";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {openCloseAnimation} from "../../animations/openCloseAnimation";
import {Group} from "../../classes/Groups/Group";
import {timer} from "rxjs";
import {filter} from "rxjs/operators";
import {CesiumAdapterService} from '@src/app/services/cesiumAdapter21/cesium-adapter.service';

@Component({
  selector: 'app-placed-item-concrete',
  templateUrl: './placed-item-concrete.component.html',
  animations: [openCloseAnimation],
  styleUrls: ['./placed-item-concrete.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlacedItemConcreteComponent extends AbstractObserver implements OnInit, AfterViewInit {

  constructor(
    private cd: ChangeDetectorRef,
    private concreteLayerService: ConcreteLayerService,
    private uiAdapter: UiAdapterService,
) {
    super();
  }

  @Input() item: ConcreteLayer | ConcreteHierarchyItemInterface;

  public topClHint = null;
  public selectedChildParent = null;
  public selected = null;
  public isTopCl = false;
  public Yiit = Yiit;
  public hasChildren = false;
  public isGrayedOut = false;
  public selectedParentIdForTopTemplate = null;
  private isInited = false;
  public isOpened = false;
  public isFirstLoad = true;
  public currentChildrenList:ConcreteHierarchyItemInterface[] = [];

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  ngOnInit() {

    this.subscribeToObservable(this.uiAdapter.selectedConcrete$, (config: ConcreteHierarchyItemInterface)=>{
      let selectedItem = this.getSelectedItemFromConfig(config);
      this.selected = (selectedItem) ? selectedItem.getCHIId() : null;
      this.isGrayedOut = !this.selectedChildParent && this.selected != this.item.getCHIId() && !this.isTopCl;
      this.cd.detectChanges();
    })

    this.subscribeToObservable(this.uiAdapter.selectedItem$, (config: ConcreteHierarchyItemInterface)=>{

      let selectedItem = this.getSelectedItemFromConfig(config);

        this.selected = (selectedItem) ? selectedItem.getCHIId() : null;

      this.selectedChildParent = (this.uiAdapter.selectedParentId && 'ConcreteLayer-'+this.uiAdapter.selectedParentId == this.item.getCHIId());
      this.isGrayedOut = !this.selectedChildParent && this.selected != this.item.getCHIId() && !this.isTopCl;

      if (this.isTopCl && selectedItem) {
        this.selectedParentIdForTopTemplate = !(selectedItem.getCHIId() == "ConcreteLayer-TOP")
      }

      this.cd.detectChanges();
    });

    this.subscribeToObservable(this.concreteLayerService.listChanged, ()=>{this.cd.detectChanges();});
  }

  ngAfterViewInit(): void {
    if (this.item.getCHIId && this.item.getCHIId() == 'ConcreteLayer-TOP'){
      let div = document.createElement('div');
      div.innerHTML = window['HINT_OUTDOOR'];
      this.topClHint =  div.innerText;
      this.isTopCl = true;
    }

    this.subscribeToObservable(this.concreteLayerService.onExpand$.pipe(filter( id => {return id == this.item.id && this.hasChildren})), ()=>{
      this.isOpened = true;
      this.cd.detectChanges();
    })

    this.subscribeToObservable(this.item.getChildren(),(config)=>{
      console.log('[TEST] item childrend', config, this.item.getTitle());
      if (config && config.length){
        if (this.item.getCHIId && this.item.getCHIId() == 'ConcreteLayer-TOP' && !this.isInited){
          //disabled top CL Open
          // this.isOpened = true;
          this.isInited = true;
        }
        // console.log('[TEST] set current children', this.item.getTitle())
        this.currentChildrenList = config.filter((i)=>{
            return !i.isOverlay && (i instanceof Group);
        }).sort((a:Group,b:Group)=>{
          return a.getTitle().toLocaleLowerCase() >= b.getTitle().toLocaleLowerCase() ? 1 : -1;
          // if (a.hasOwnProperty('position') && b.hasOwnProperty('position')){
          //   return a.position - b.position;
          // }
          // return 0;
        });

        console.log('[TEST] childrens', this.item.getTitle(), this.currentChildrenList.length);
        this.hasChildren = this.currentChildrenList.length > 0;
        this.cd.detectChanges();
      }
      else{
        // console.log('[TEST] no chld', this.item.getTitle())
        this.currentChildrenList = [];
        this.hasChildren = false;
        this.cd.detectChanges();
      }
      timer(1000).subscribe(()=>{
        this.isFirstLoad = false;
        this.cd.detectChanges();
      });
    });

    this.cd.detectChanges();
  }


  getSelectedItemFromConfig(config){
      return config;
  }

  getCHIId(){
    return this.item.getCHIId();
  }


  toggleOpenStatus(){
    this.isOpened = !this.isOpened;
    this.cd.detectChanges();
  }


  getItemDetails(dontSaveConfig?){
    this.item.onSelect();
    this.uiAdapter.selectedItem$ = this.item;
    this.concreteLayerService.selectedConcrete = this.item;
  }

  isActive(){
    return this.selected && this.item.getCHIId() == this.selected;
  }

  isContainVisibleItem(){
    return this.currentChildrenList.some(i => !i.is_empty);
  }
}
